import { AnyAction } from 'redux';
import types from '../constants';

const defaultState: any[] = [];
export default (state = defaultState, { payload, type }: AnyAction) => {
  switch (type) {
    case types.event_selectors.set:
      return [...payload];
    case types.event_selectors.clear:
      return defaultState;

    default:
      return state;
  }
};
